'use strict';
import React, { PureComponent } from 'react';
import BuscadorCuentasContables from '../../../Common/BuscadorCuentasContables';
import GrupoRadioButton from '../../../Common/GrupoRadioButton';


class DatosContables extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarOpcionCombo = this.cambiarOpcionCombo.bind(this);
    }

    cambiarOpcionCombo(nombreCombo, valorCombo) {
        this.props.cambiarOpcionCombo(nombreCombo, valorCombo);
    }

    render() {
        const {
            buscarCuentasContables,
            cambiarOpcionCombo,
            cambiarInputActivo,
            cambiarValorInput,
            comboCentroDeCosto,
            comboCentroCostoSeleccionado,
            cuentasContablesFiltradas,
            cuentaSeleccionada,
            errorValidacion,
            guardarValorInput,
            inputActivo,
            inputsAltaEdicionRenglonContable,
            rbModalAltaEdicionRenglonContable,
            seleccionarRadioButtonABMModelos
        } = this.props;

        let positionRelative=true;
        let inputNombre = "inputCuentaContable";
        let arrayOpcionesCentroCosto = [];
        let comboCentroCosto = comboCentroDeCosto ? comboCentroDeCosto : [];

        arrayOpcionesCentroCosto.push(
            <option key={0} value={0}>Ninguno</option>
        );
        arrayOpcionesCentroCosto.push(
            <option key={999} value={999}>Relativo a la sucursal</option>
        );

        comboCentroDeCosto?.map(centroCosto => {
            arrayOpcionesCentroCosto.push(
                <option key={centroCosto.Id} value={centroCosto.Id}>{centroCosto.Descripcion}</option>
            );
        });
        return (
            <div>
                <div className="ABMModelosModalContainer__subtitulo ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorSubtitulo">Datos contables</div>

                <div className="ABMModelosModalContainer__contenedorGrupoRadioButtons">
                    <div className="seccionDatosGenerales__tituloSecundario">Tipo operación</div>

                    <div>
                        {rbModalAltaEdicionRenglonContable.rbTipoRenglon == 3 ?
                  <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierdaAmbas">
                        <GrupoRadioButton 
                            activo={rbModalAltaEdicionRenglonContable.rbTipoOperacion == 0}
                            classLabel={""}
                            estaHabilitado={true}
                            label={"Ambas"}
                            nombre={"rbTipoOperacion"}
                            onClick={seleccionarRadioButtonABMModelos}
                            seccion={"modalAltaEdicionRenglonContable"}
                            valor={0}
                        />
                    </div>
                    :
                    null
                        }   
                        <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierdaPequeño">
                            <GrupoRadioButton 
                                activo={rbModalAltaEdicionRenglonContable.rbTipoOperacion == 1}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Débito"}
                                nombre={"rbTipoOperacion"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={1}
                            />
                        </div>

                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                            <GrupoRadioButton 
                                activo={rbModalAltaEdicionRenglonContable.rbTipoOperacion == 2}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Crédito"}
                                nombre={"rbTipoOperacion"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={2}
                            />
                        </div>
                    </div>
                </div>

                <div className="ABMModelosModalContainer__contenedorGrupoRadioButtons">
                    <div className="seccionDatosGenerales__tituloSecundario">Moneda de salida</div>

                    <div>
                        <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierdaPequeño">
                            <GrupoRadioButton 
                                activo={rbModalAltaEdicionRenglonContable.rbMonedaSalida == "P" || rbModalAltaEdicionRenglonContable.rbMonedaSalida == 1}
                                classLabel={null}
                                estaHabilitado={true}
                                label={"Peso"}
                                nombre={"rbMonedaSalida"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={"P"}
                            />
                        </div>

                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                            <GrupoRadioButton 
                                activo={rbModalAltaEdicionRenglonContable.rbMonedaSalida == "D" || rbModalAltaEdicionRenglonContable.rbMonedaSalida == 2}
                                classLabel={null}
                                estaHabilitado={true}
                                label={"Dólar"}
                                nombre={"rbMonedaSalida"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={"D"}
                            />
                        </div>
                    </div>
                </div>
                <div>          
                    <div className={"ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorCuentaContable" + (inputNombre == inputActivo & positionRelative ?  " ABMModelosModalContainer__PositionRelative" : "")}>
                        <div className="seccionDatosGenerales__tituloSecundario">Cuenta Contable</div>

                        <BuscadorCuentasContables 
                            //TODO: eliminar esta variable cuando se haga la interactividad de modal ModalAltaEdicionRenglonContable
                            buscarCuentasContables={buscarCuentasContables}
                            cambiarInputActivo={cambiarInputActivo}
                            cambiarValorInput={cambiarValorInput}
                            cuentasContables={cuentasContablesFiltradas}
                            errorValidacion={errorValidacion}
                            estaHabilitado={true}
                            estiloPlaceholder={""}
                            guardarValorInput={guardarValorInput}
                            inputActivo={inputActivo}
                            nombreInput={"inputCuentaContable"}
                            seccionInput={"modalAltaEdicionRenglonContable"}
                            valorInput={inputsAltaEdicionRenglonContable.inputCuentaContable}
                            inputClassValorSeleccionado={Boolean(cuentaSeleccionada) ? " ABMModelos__buscadorCuentasContables--valorSeleccionado" : ""}
                            contenedorInputBuscador={"ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorInputBuscador"}
                        />
                        {errorValidacion.modalAltaEdicionRenglonContable.inputCuentaContable ? 
                        <div>
                            <label className="error">{errorValidacion.modalAltaEdicionRenglonContable.inputCuentaContable}</label>
                        </div>
                    :
                        null
                    }                          
                    </div>
                </div>           
                <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorCuentaContable ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorCentroDeCosto">
                    <div className="seccionDatosGenerales__tituloSecundario">Centro de costo</div>

                    <div>
                        <select 
                            className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect ABMModelos__seccionDatosGenerales__sucursalSelect"
                            
                            name="comboCentroCostoSeleccionado"
                            onChange={(event) => {
                                const indice = event.target.selectedIndex;
                                const opcion = event.target.options[indice].value;
                                this.cambiarOpcionCombo("comboCentroCostoSeleccionado", opcion)
                            }}
                            value={comboCentroCostoSeleccionado}>
                            {arrayOpcionesCentroCosto}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

export default DatosContables;